import { inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HubConnectionService {
  private url: string = environment.url.split('/api')[0];
  private hubConnection: signalR.HubConnection | null = null;
  private messageReceived = new Subject<{ message: string }>();

  constructor() {}

  public configureHub(hubName: string, receiveEndpoint: string): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.url}/${hubName}`, { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
      .withAutomaticReconnect()
      .build();

    this.startConnection();
    this.registerOnServerEvents(receiveEndpoint);
  }

  private startConnection() {
    this.hubConnection!
      .start()
      .then(() => console.log('SignalR connection started'))
      .catch(err => console.error('Error while starting SignalR connection:', err));
  }

  private registerOnServerEvents(receiveEndpoint: string) {
    this.hubConnection!.on(receiveEndpoint, (message: string) => {
      console.log('received message', message)
      this.messageReceived.next({ message });
    });
  }

  public getMessages(): Observable<{ message: string }> {
    return this.messageReceived.asObservable();
  }

  public stopConnection() {
    if(this.hubConnection && this.hubConnection.state == signalR.HubConnectionState.Connected)
    {
      this.hubConnection.stop();
    }
  }
}
